export default __webpack_public_path__ + "static/media/mc-icon.84f75168.svg";